import { render } from "./ClickToCall.vue?vue&type=template&id=e00c63c0&scoped=true&ts=true"
import script from "./ClickToCall.vue?vue&type=script&lang=ts"
export * from "./ClickToCall.vue?vue&type=script&lang=ts"

import "./ClickToCall.vue?vue&type=style&index=0&id=e00c63c0&scoped=true&lang=css"

import exportComponent from "C:\\Jenkins\\workspace\\Mock_develop\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e00c63c0"]])

export default __exports__